module.exports = __webpack_public_path__ + "img/Last image OOBE Korean.6ff599ec.png";